import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import { getSuperAdminSelector } from '../../../../../../../redux/reducers/reducerSlices/SuperAdminReducerSlice';
import DrilldownTable from '../../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTable';
import { dateAndTimeLocal } from '../../../../../../Assests/Utility';
import moment from 'moment';

/**
 * Component renders as a modal to show history log for a given Help/Feedback record.
 * Passed `data` prop = { Id, type } of the selected record.
 */
const HelpFeedbackHistory = (props) => {
    const { themeSelected = 'light-mode', data } = props;
    const dispatch = useDispatch();
    const superAdminSagaObj = useSelector(getSuperAdminSelector);
    const { helpAndFeedbackHistoryList, isHistoryLoading } = superAdminSagaObj;
    const [historyList, setHistoryList] = useState([]);

    const columnTitle = [
        { id: '', name: 'S.No' },
        { id: 'status', name: 'Status' },
        { id: 'changedBy', name: 'Changed By' },
        { id: 'changedOn', name: 'Changed On' },
        { id: 'remarks', name: 'Remarks' },
    ];

    // Reset history list on mount and fetch fresh data
    useEffect(() => {
        dispatch({ type: sagaActions.RESET_HELP_FEEDBACK_HISTORY });
        setHistoryList([]);
    }, []);

    useEffect(() => {
        fetchHistory();
    }, []);

    useEffect(() => {
        if (helpAndFeedbackHistoryList && helpAndFeedbackHistoryList.length) {
            setHistoryList(helpAndFeedbackHistoryList);
        } else {
            setHistoryList([]);
        }
    }, [helpAndFeedbackHistoryList]);

    const fetchHistory = () => {
        const apiParams = {
            helpAndFeedbackId: data?.Id
        };
        dispatch({ type: sagaActions.GET_HELP_FEEDBACK_HISTORY, payload: apiParams });
    };

    const getLocalTime = (timeStr) => {
        if (!timeStr) return '-';
        let m = moment.tz(timeStr, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]', 'America/Denver');
        m.tz(moment.tz.guess()).format();
        const localTime = dateAndTimeLocal(m.toString());
        return `${localTime.date} ${localTime.time}`;
    };

    const formatListData = (data) => {
        return data.map((el, index) => ({
            id: el.LogId || index,
            0: <div>{index + 1}</div>,
            1: <div>{el.status || '-'}</div>,
            2: <div>{el.changedByName || '-'}</div>,
            3: <div>{getLocalTime(el.changedOn)}</div>,
            4: <div>{el.remarks || '-'}</div>,
        }));
    };

    return (
        <div className='p-3' style={{ minWidth: '60vw' }}>
            <h5 className='mb-3'>
                {`History Log — ${data?.type || ''} #${data?.Id || ''}`}
            </h5>
            <DrilldownTable
                themeSelected={themeSelected}
                bodyData={historyList.length ? formatListData(historyList) : []}
                titleData={columnTitle}
                showCollapse={false}
                showInput={false}
                showSort={false}
                drillDownReport={historyList}
                initiateDrillDownReport={isHistoryLoading}
                loaderArray={5}
                showUTCTime={false}
                subRoot={{ pathName: 'helpFeedbackHistory' }}
            />
        </div>
    );
};

export default HelpFeedbackHistory;
